import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import CryptoJS from "crypto-js";
import { Base64 } from "js-base64";
/**
 * 回显字典的值
 * @param arr
 * @param targetValue
 */
export function getDictLabel(arr, value) {
  return arr.some(ele => ele.value == value) ? arr.filter(key => key.value == value)[0].label : "";
}
/**
 * 对象数组排序
 * @param arr
 * @param filed
 */
export function sortObjArr(arr, filed) {
  function compare(filed) {
    return function (a, b) {
      const value1 = a[filed];
      const value2 = b[filed];
      return value1 - value2;
    };
  }
  return arr.sort(compare(filed));
}
/**
 * JSON 数组去重
 * @param arr
 * @param field
 */
export function jsonArrUnique(arr, field) {
  const obj = {};
  const result = [];
  arr.forEach(item => {
    if (!obj[field]) {
      result.push(item);
      obj[field] = true;
    }
  });
  return result;
}
/**
 *加密处理
 */
export const encryption = params => {
  const {
    data,
    type,
    param
  } = params;
  let {
    key
  } = params;
  const result = JSON.parse(JSON.stringify(data));
  if (type === "Base64") {
    param.forEach(ele => {
      result[ele] = btoa(result[ele]);
    });
  } else {
    param.forEach(ele => {
      const data = result[ele];
      key = CryptoJS.enc.Latin1.parse(key);
      const iv = key;
      // 加密
      const encrypted = CryptoJS.AES.encrypt(data, key, {
        iv: iv,
        mode: CryptoJS.mode.CFB,
        padding: CryptoJS.pad.NoPadding
      });
      result[ele] = encrypted.toString();
    });
  }
  return result;
};
/**
 * 去掉无意义的0
 * @param num
 * @returns
 */
export function removeZero(num) {
  const result = parseFloat(parseFloat(num).toFixed(2));
  return result;
}
/**
 * 格式化文件大小
 * @param size
 * @returns
 */
export function fileSizeFormat(size) {
  const kb = Number(size) / 1024;
  if (kb < 1000) return removeZero(kb) + "KB";
  const M = kb / 1024;
  if (M < 1000) return removeZero(M) + "MB";
  const G = M / 1024;
  return removeZero(G) + "GB";
}
/**
 * @description 时间格式化
 * @param {String} 格式化字符串 格式如：YYYY-mm-dd HH:MM:SS
 * @param {Date} date对象
 * @return {String}
 */
export function dateFormat(date, fmt = "YYYY-MM-DD HH:mm") {
  if (!date) return "-";
  const ndata = ["string", "number"].includes(typeof date) ? new Date(date) : date;
  let ret;
  const opt = {
    "Y+": ndata?.getFullYear().toString(),
    "y+": ndata?.getFullYear().toString(),
    "M+": (ndata?.getMonth() + 1).toString(),
    "D+": ndata?.getDate().toString(),
    "h+": ndata?.getHours().toString(),
    "H+": ndata?.getHours().toString(),
    "m+": ndata?.getMinutes().toString(),
    "s+": ndata?.getSeconds().toString(),
    x: ndata?.valueOf().toString()
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };

  for (const k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(ret[1], ret[1].length === 1 ? opt[k] : opt[k]?.padStart(ret[1].length, "0"));
    }
  }
  return fmt;
}
export function formatSecondsLength(value, local = true) {
  let secondTime = typeof value === "string" ? parseInt(value) : value || 0;
  let minuteTime = 0;
  let hourTime = 0;
  if (secondTime > 60) {
    minuteTime = Math.floor(secondTime / 60);
    secondTime = Math.floor(secondTime % 60);
  }
  if (minuteTime > 60) {
    hourTime = Math.floor(minuteTime / 60);
    minuteTime = Math.floor(minuteTime % 60);
  }
  const localName = ["小时", "分钟", "秒"];
  if (local) {
    return [hourTime, minuteTime, secondTime].reduce((acc, cur, currentIndex) => {
      if (!cur) return acc;
      acc += String(cur);
      acc += localName[currentIndex];
      return acc;
    }, "");
  }
  return [hourTime, minuteTime, secondTime].reduce((acc, cur, currentIndex) => {
    // if (!(cur || acc)) return acc
    acc += String(cur).padStart(2, "0");
    if (currentIndex < 2) {
      acc += ":";
    }
    return acc;
  }, "");
}
/**
 * 字符串转到驼峰
 * splitStr: 规制的字符串 -(默认) 或者_
 * type : 1 大驼峰（默认） 2 小驼峰
 */
export function stringToHump(str, splitStr = "-", type = 1) {
  const arr = str.split(splitStr);
  let resStr = arr.reduce(function (prev, cur) {
    const str = prev + cur.slice(0, 1).toUpperCase() + cur.slice(1);
    return str;
  });
  if (type == 1) {
    // 转小驼峰这一行不需要
    resStr = resStr.slice(0, 1).toUpperCase() + resStr.slice(1);
  }
  return resStr;
}
/**
 * wait等待
 */
export function wait(timeout = 1000) {
  return new Promise(resolve => {
    setTimeout(resolve, timeout);
  });
}
// 节流
function Shake() {
  let timer = -1;
  return function (obj, millisecond = 300) {
    clearTimeout(timer);
    timer = setTimeout(obj, millisecond);
  };
}
export const shake = Shake();
// 防抖
function Debounce() {
  const keys = [];
  return function (obj, millisecond = 300, key = "") {
    if (keys.indexOf(key) !== -1) {
      return;
    }
    obj();
    const index = keys.length;
    keys[index] = key;
    setTimeout(() => {
      keys.splice(index, 1);
    }, millisecond);
    return true;
  };
}
export const debounce = Debounce();
export async function AwaitDebounce(millisecond = 300, key = "") {
  return new Promise((resolve, reject) => {
    const result = debounce(() => {
      resolve();
    }, millisecond, key);
    if (!result) {
      reject();
    }
  });
}
export function downloadDataURLFile(base64, fileName = "excel.xlsx") {
  const arr = base64.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  const blob = new Blob([u8arr], {
    type: mime
  });
  downloadBlobFile(blob, fileName);
}
export function downloadBlobFile(blobObject, fileName = "excel.xlsx") {
  const blob = new Blob([blobObject], {
    type: blobObject.type
  });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
}
export function downloadFile(url, fileName) {
  const tempLink = document.createElement("a"); // 创建a标签
  tempLink.href = url;
  tempLink.target = "_blank";
  tempLink.download = fileName || "";
  document.body.appendChild(tempLink);
  tempLink.click(); // 点击下载
  document.body.removeChild(tempLink); // 下载完成移除元素
}
// 下载文本
export function downloadBlobString(data, filename, type) {
  const blob = new Blob([data]);
  const tempLink = document.createElement("a"); // 创建a标签
  const href = window.URL.createObjectURL(blob); // 创建下载的链接
  //filename
  const fileName = `${filename}.${type}`;
  tempLink.href = href;
  tempLink.target = "_blank";
  tempLink.download = fileName;
  document.body.appendChild(tempLink);
  tempLink.click(); // 点击下载
  document.body.removeChild(tempLink); // 下载完成移除元素
  window.URL.revokeObjectURL(href); // 释放掉blob对象
}

export function getFileUrl(file) {
  const prefix = process.env.VUE_APP_NETWORK_OSS_BUCKET || "/oss";
  if (file.url) {
    return (file.url.includes(prefix) ? '' : prefix) + file.url;
  } else {
    return prefix + `/${file.bucketName}/${file.fileName}`;
  }
}
export function getOssUrl(file) {
  return `${process.env.VUE_APP_PRIVATE_OSS_BUCKET || 'http://zbcloud-minio:9000'}/${file.bucketName}/${file.fileName}`;
}
export async function previewFileUrl(fileUrl) {
  try {
    if (!fileUrl) throw new Error("没有文件 URL");
    const origin = process.env.VUE_APP_NODE_ENV === "development" ? process.env.VUE_APP_PROXY_OSS_TARGET : window.location.origin;
    const urlList = (Array.isArray(fileUrl) ? fileUrl : [fileUrl]).map(url => {
      return url.startsWith('http') ? url : origin + url;
    });
    console.log('getFileUrl', urlList);
    const imgList = urlList.map(url => /.(png|jpg|jpeg|svg|gif)$/.test(url));
    const showManyImg = imgList.length > 1;
    const urlStr = showManyImg ? urlList.join("|") : urlList[0];
    console.log("preview url", urlStr);
    return `${origin}/filePreview/${showManyImg ? "picturesPreview?urls" : "onlinePreview?url"}=${encodeURIComponent(Base64.encode(urlStr))}`;
  } catch (e) {
    console.error(e);
  }
}
export async function previewFile(fileUrl) {
  try {
    const viewUrl = await previewFileUrl(fileUrl);
    console.log("preview platform url", viewUrl);
    if (!viewUrl) return;
    const win = window.open("about:blank");
    win && (win.location.href = viewUrl);
  } catch (e) {
    console.error(e);
  }
}
export function arrayToObject(arr, key) {
  const obj = {};
  arr.forEach(item => {
    obj[item[key]] = item;
  });
  return obj;
}
export function objectToArray(obj) {
  const arr = [];
  Object.keys(obj).forEach(objKey => {
    arr.push(obj[objKey]);
  });
  return arr;
}
export function mapDatasets(datasets, key = "value") {
  const map = new Map();
  if (!Array.isArray(datasets)) return map;
  datasets.forEach(item => {
    if (item[key] === undefined) return;
    map.set(item[key], item);
  });
  return map;
}
export function run(expression, params = {}) {
  // return eval.call(params, expression)
  return Function(...Object.keys(params), `
        "use strict";
        return (${expression})
    `)(...Object.values(params));
}
/**
 * 根据值，从数组中获取当前选中的数据
 * @param nodeValue
 * @param allTreeData
 */
export function findTreeCureentNodeByValue(nodeValue, allTreeData) {
  function treeFind(tree) {
    for (const item of tree) {
      if (item.value == nodeValue) return item;
      if (item?.children?.length) {
        const res = treeFind(item.children);
        if (res) return res;
      }
    }
    return null;
  }
  return treeFind(allTreeData);
}
export function isVideoFile(string) {
  return ["avi", "wmv", "mpg", "mpeg", "mov", "rm", "ram", "swf", "flv", "mp4", "mp3", "wma", "avi", "rm", "rmvb", "flv", "mpg", "mkv"].includes(string.toLowerCase());
}
export function isVideoMimeType(string) {
  return new RegExp(/video\/.+/g).test(string);
}
export function getVideoDuration(src) {
  return new Promise((resolve, reject) => {
    const viedo = new Audio(src);
    viedo.addEventListener("loadedmetadata", () => {
      resolve(viedo.duration);
    });
  });
}
/**
 * 复制文本内容
 * @param content 文本内容
 * @returns result <boolean>
 */
export function copyText(content) {
  // 设置想要复制的文本内容
  const text = content || "让我们一起快乐的敲代码吧~";
  // 判断是否支持clipboard方式
  if (window.navigator.clipboard) {
    return window.navigator.clipboard.writeText(text);
  } else {
    // 不支持clipboard方式 则采用document.execCommand()方式
    // 创建一个input元素
    const inputDom = document.createElement("textarea");
    // 设置为只读 防止移动端手机上弹出软键盘
    inputDom.setAttribute("readonly", "readonly");
    // 给input元素赋值
    inputDom.value = text;
    // 将创建的input添加到body
    document.body.appendChild(inputDom);
    // 选中input元素的内容
    inputDom.select();
    // 执行浏览器复制命令
    // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签中的内容）
    // Input要在正常的编辑状态下原生复制方法才会生效
    const result = document.execCommand("copy");
    // 判断是否复制成功
    document.body.removeChild(inputDom);
    if (result) {
      return Promise.resolve();
    } else {
      return Promise.reject();
    }
  }
}
export function imageToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = error => reject(error);
  });
}
export function isPrivateIP(ip) {
  // 匹配内网地址的正则表达式
  const privateIPRegex = /^(10\.\d{1,3}\.\d{1,3}\.\d{1,3}|172\.(1[6-9]|2[0-9]|3[0-1])\.\d{1,3}\.\d{1,3}|192\.168\.\d{1,3}\.\d{1,3})$/;
  return privateIPRegex.test(ip);
}
export function completeUrl(wasteUrl, config) {
  const urlFragment = {
    protocol: wasteUrl.match(/^([a-z]+):/i)?.[0] || '',
    hostname: wasteUrl.match(/(([a-zA-Z0-9]*\.)+[a-zA-Z0-9]*)/i)?.[1] || '',
    port: wasteUrl.match(/:(\d+)/)?.[1] || '',
    pathname: wasteUrl.match(/\/[^?#]*/i)?.[0] || '',
    search: wasteUrl.match(/\?(.*)/i)?.[0] || '',
    hash: wasteUrl.match(/#(.*)/i)?.[0] || ''
  };
  console.log('completeUrl', urlFragment);
  return new URL(`${urlFragment.protocol || location.protocol}//${urlFragment.hostname || location.hostname}${urlFragment.port || location.port ? ':' : ''}${urlFragment.port || location.port}${urlFragment.pathname || (config?.completePathname ? location.pathname : '')}${urlFragment.search || (config?.completeSearch ? location.search : '')}${urlFragment.hash || (config?.completeHash ? location.hash : '')}`);
}